import maplibregl from 'maplibre-gl';
import { Protocol } from 'pmtiles';

let pmtilesProtocolRegistered = false;

/**
 * Регистрирует схему `pmtiles://` для vector / raster-dem источников в JSON стилях.
 * Без этого MapLibre не умеет читать `.pmtiles` по HTTPS — нужен префикс `pmtiles://` + этот хук.
 * Идемпотентно (HMR / повторный импорт).
 */
export function registerPmtilesProtocol(): void {
  if (pmtilesProtocolRegistered) {
    return;
  }
  pmtilesProtocolRegistered = true;
  const protocol = new Protocol({ metadata: true });
  maplibregl.addProtocol('pmtiles', protocol.tile);
}
